<template>
  <section id="tour_booking_submission" class="section_padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="tour_details_right_sidebar_wrapper">
            <div class="tour_detail_right_sidebar">
              <div class="tour_details_right_boxed mb-2">
                <div class="tour_details_right_box_heading">
                  <h3>{{ propertyName }}</h3>
                </div>
              </div>
              <div class="tour_details_right_boxed">
                <div class="tour_details_right_box_heading">
                  <h3>{{ $t('booking_data') }}</h3>
                </div>
                <div class="valid_date_area">
                  <div class="valid_date_area_one">
                    <h5>{{ $t('check_in') }}</h5>
                    <p>{{ start_date }}</p>
                  </div>
                  <div class="valid_date_area_one">
                    <h5>{{ $t('check_out') }}</h5>
                    <p>{{ end_date }}</p>
                  </div>
                </div>
                <hr />
                <div class="tour_details_right_box_heading">
                  <h4>{{ $t('stay_duration') }}</h4>
                  <h5>
                    {{ diffInDays }}
                    {{ diffInDays > 1 ? $t('nights') : $t('night') }}
                  </h5>
                </div>
                <hr />
                <div class="tour_booking_amount_area">
                  <h5>{{ $t('selected_rooms') }}</h5>
                  <ul>
                    <li v-for="room in selectedRooms" :key="room.roomId">
                      {{ room.selectedQuantity }} x {{ room.roomName }}
                      <span>
                        {{ selectedRooms.length > 0 ? selectedRooms[0].currency : "" }}
                        {{ (room.totalPrice * room.selectedQuantity).toLocaleString("es-ES", {
                          minimumFractionDigits: 2,
                        }) }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="tour_detail_right_sidebar">
              <div class="tour_details_right_boxed">
                <div class="tour_details_right_box_heading">
                  <h3>{{ $t('price_breakdown') }}</h3>
                </div>

                <div class="tour_booking_amount_area">
                  <ul>
                    <li>
                      {{ $t('stay_for') }} {{ diffInDays }}
                      {{ diffInDays > 1 ? $t('nights') : $t('night') }}
                      <span>
                        {{ selectedRooms.length > 0 ? selectedRooms[0].currency : "" }}
                        {{
                          totalAmount.toLocaleString("es-ES", {
                            minimumFractionDigits: 2,
                          })
                        }}
                      </span>
                    </li>
                  </ul>
                  <div class="tour_bokking_subtotal_area">
                    <h6>
                      {{ $t('subtotal') }}
                      <span>
                        {{ selectedRooms.length > 0 ? selectedRooms[0].currency : "" }}
                        {{
                          totalAmount.toLocaleString("es-ES", {
                            minimumFractionDigits: 2,
                          })
                        }}
                      </span>
                    </h6>
                  </div>
                  <div class="total_subtotal_booking">
                    <h6>
                      {{ $t('total_amount') }}
                      <span>
                        {{ selectedRooms.length > 0 ? selectedRooms[0].currency : "" }}
                        {{
                          totalAmount.toLocaleString("es-ES", {
                            minimumFractionDigits: 2,
                          })
                        }}
                      </span>
                    </h6>
                    <sub v-if="!(totalTaxesDisplayAmount > 0)">{{ $t('taxes_included') }}</sub>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="totalTaxesDisplayAmount > 0" class="tour_detail_right_sidebar">
              <div class="tour_details_right_boxed">
                <div class="tour_details_right_box_heading">
                  <h3>{{ $t('price_info') }}</h3>
                </div>

                <div class="tour_booking_amount_area">
                  <ul>
                    <li>
                      {{ $t('not_included') }}
                      {{ selectedRooms.length > 0 ? selectedRooms[0].currency : "" }}
                      {{
                        totalTaxesDisplayAmount.toLocaleString("es-ES", {
                          minimumFractionDigits: 2,
                        })
                      }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="tou_booking_form_Wrapper">
            <div class="booking_tour_form">
              <h3 class="heading_theme">{{ $t('booking_submission') }}</h3>
              <div class="tour_booking_form_box">
                <form action="!#" id="tour_bookking_form_item">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <input type="text" class="form-control bg_input" :placeholder="$t('first_name')"
                          v-model="form.first_name" />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <input type="text" class="form-control bg_input" :placeholder="$t('last_name')"
                          v-model="form.last_name" />
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <input type="text" class="form-control bg_input" :placeholder="$t('address')"
                          v-model="form.address" />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <v-select class="form-control bg_input" v-model="countrySelected" label="text"
                          :placeholder="$t('country')" :disabled="true"></v-select>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <input type="text" class="form-control bg_input" :placeholder="$t('email')"
                          v-model="form.email" />
                        <sub>{{ $t('confirmation_email_note') }}</sub>
                      </div>
                    </div>

                    <div class="col-lg-6">
                      <div class="form-group">
                        <input type="text" class="form-control bg_input" :placeholder="$t('phone_number') + '*'"
                          v-model="form.phone" />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <input type="date" class="form-control bg_input" v-model="form.birthdate" />
                        <sub>{{ $t('birthdate') }}</sub>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <sub>{{ $t('special_requests') }}</sub>
                    <textarea rows="5" class="form-control bg_input" :placeholder="$t('special_requests_placeholder')"
                      v-model="form.specialRequests"></textarea>
                  </div>
                  <div class="form-check px-0 ">
                    <label class="form-check-label  m-0">
                      <input class="form-check-input mx-1" type="checkbox" v-model="form.acceptTerms" />
                      {{ $t("i_accept_terms_and_conditions") }}.

                      <a class="btn btn-link fs-sm-2 mx-0 p-0 small text-info text-decoration-underline" href="#"
                        @click.stop.prevent="openInNewTab">
                        {{ $t('view') }}
                      </a>
                    </label>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-end">
          <button class="btn btn_theme  btn_md" @click="saveBooking">{{ $t('booking_submission') }}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import { mapState, mapActions } from "vuex";
import {
  API_BASE_URL,
  COUNTRY_API,
  SAVE_HGS_BOOKING_API,
  SAVE_CHN_BOOKING_API,
} from "@/api-config";
export default {
  name: "TourBookingSubmission",
  data() {
    return {
      countries: [],
      countrySelected: null,
      propertyName: "",
      propertyId: "",
      start_date: "",
      end_date: "",
      selectedRooms: [],
      diffInDays: 0,
      form: {
        first_name: "",
        last_name: "",
        address: "",
        country: "",
        email: "",
        phone: "",
        birthdate: "",
        specialRequests: [],
        acceptTerms: false,
      },
    };
  },
  computed: {
    ...mapState({
      error: (state) => state.form.error,
    }),

    formatDate() {
      if (!this.form.birthdate) return "";
      const [year, month, day] = this.form.birthdate.split("-");
      return `${month}/${day}/${year}`;
    },

    filteredCountries() {
      if (this.searchCountry) {
        return this.countries.filter((country) =>
          country.text.toLowerCase().includes(this.searchCountry.toLowerCase())
        );
      }
      return this.countries;
    },

    totalAmount() {
      if (Array.isArray(this.selectedRooms)) {
        return this.selectedRooms.reduce((total, room) => {
          return total + room.selectedQuantity * room.totalPrice;
        }, 0);
      }
      return 0;
    },

    totalTaxesDisplayAmount() {
      if (Array.isArray(this.selectedRooms)) {
        return this.selectedRooms.reduce((total, room) => {
          return total + room.totalTaxesDisplay;
        }, 0);
      }
      return 0;
    },
    user() {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : {};
    },
  },
  mounted() {
    const token = this.$route.query.token;
    const stored = localStorage.getItem(`booking_${token}`);

    const user = this.user;
    this.form.first_name = user.name || "";
    this.form.email = user.email || "";
    this.form.address = user.address || "";
    this.form.phone = user.phones_access || "";
    this.form.birthdate = user.birth_date || "";

    if (stored) {
      const data = JSON.parse(stored);
      this.getCountries();
      this.selectedRooms = Array.isArray(data.rooms)
        ? data.rooms
        : [];
      this.propertyId = this.$route.params.id;
      this.propertyName = data.propertyName;
      this.propertyContact = data.propertyContact;
      this.start_date = data.start_date;
      this.end_date = data.end_date;
      this.customerNationality = data.customerNationality;
      this.key = this.$route.query.key;
      this.calculateDiffInDays();
    } else {
      this.showAlert("Token invalido.");
      setTimeout(() => {
        window.history.back();
      }, 2500);
    }


  },
  methods: {
    ...mapActions("form", ["updateError"]),

    hideLoading() {
      Swal.close();
    },
    showLoading() {
      Swal.fire({
        title: 'Cargando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    },
    updateDate(date) {
      if (date) {
        const [year, month, day] = date.split("-");
        this.form.birthdate = `${year}-${month}-${day}`;
      }
    },

    showAlert(message, type) {
      Swal.fire({
        icon: type,
        title: type === "success" ? "Éxito" : "Error",
        text: message,
      }).then((confirm) => {
        this.updateError({ status: false, message: "" });
      });
    },

    getCountries() {
      axios
        .get(`${API_BASE_URL}${COUNTRY_API}`)
        .then((response) => {
          this.countries = response.data.results;
          let selectedcustomerNationality = this.countries.find(
            (nat) => nat.slug === this.customerNationality
          );
          if (selectedcustomerNationality) {
            this.countrySelected = selectedcustomerNationality.text;
          } else {
            // console.log("No se encontró el país con ese slug.");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    calculateDiffInDays() {
      if (this.start_date && this.end_date) {
        this.diffInDays =
          (new Date(this.end_date) - new Date(this.start_date)) / (1000 * 3600 * 24);
      }
    },

    openInNewTab() {
      const url = this.$router.resolve({
        name: "terms-service",
      }).href;

      window.open(url, "_blank", "noopener,noreferrer");
    },

    validateForm() {
      const messages = {
        first_name: this.$t("please_enter_your_first_name"),
        last_name: this.$t("please_enter_your_last_name"),
        address: this.$t("please_enter_your_address"),
        email: this.$t("please_enter_your_email"),
        phone: this.$t("please_enter_your_phone_number"),
        birthdate: this.$t("please_select_your_date_of_birth"),
        acceptTerms: this.$t("please_accept_terms_and_conditions"),
      };

      for (const [key, message] of Object.entries(messages)) {
        if (!this.form[key] || (key === "countrySelected" && !this.countrySelected)) {
          return message;
        }
      }

      return null;
    },

    saveBooking() {
      const validationError = this.validateForm();
      if (validationError) {
        this.showAlert(validationError, "error");
        return;
      }

      const _first = this.form.first_name;
      const _last = this.form.last_name;
      const guestsPerRoom = (room) => {
        const guests = [];
        for (let i = 0; i < room.guestAdults; i++) {
          guests.push({
            birthDate: this.form.birthdate,
            name: {
              first: _first,
              last: _last,
            },
          });
        }

        Array.from(room.guestChildren).forEach(function (element) {
          const today = new Date();

          today.setFullYear(today.getFullYear() - element);

          const day = String(today.getDate()).padStart(2, "0");
          const month = String(today.getMonth() + 1).padStart(2, "0");
          const year = today.getFullYear();

          const formattedDate = `${year}/${month}/${day}`;

          guests.push({
            birthDate: formattedDate,
            name: {
              first: _first,
              last: _last,
            },
          });
        });
        return guests;
      };

      const specialRequestsArray = Array.isArray(this.form.specialRequests)
        ? this.form.specialRequests
        : this.form.specialRequests
          ? this.form.specialRequests
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0)
          : [];

      const bookingData = {
        dates: {
          from: this.start_date,
          to: this.end_date,
        },
        propertyId: this.propertyId,
        propertyName: this.propertyName,
        propertyContact: this.propertyContact,
        leadGuest: {
          birthDate: this.formatDate,
          contact: {
            address: this.form.address,
            city: "N/A",
            country: this.customerNationality,
            email: this.form.email,
            phone: this.form.phone,
            state: "N/A",
            zip: "N/A",
          },
          name: {
            first: this.form.first_name,
            last: this.form.last_name,
          },
          title: "MR",
        },
        rooms: [],
      };

      this.selectedRooms.forEach((room) => {
        for (let i = 0; i < room.selectedQuantity; i++) {
          bookingData.rooms.push({
            roomId: room.roomId,
            roomName: room.roomName,
            rateCode: room.ratePlanCode,
            options: room.ratePlanOptions,
            expectedPrice: {
              searchCurrency: room.searchCurrency,
              currency: room.currency,
              commission: room.commission,
              total: room.totalPrice,
              amount: room.pricePerRoom,
              discount: room.discount,
              promotion: room.promotion,
              data: room.data,
            },
            guests: guestsPerRoom(room),
            specialRequests: specialRequestsArray,
            nightlyBreakdown: room.nightlyBreakdown,
            searchedPax: room.searchedPax,
          });
        }
      });

      const token = localStorage.getItem("authToken");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const apiUrl =
        this.key === "chn"
          ? `${API_BASE_URL}${SAVE_CHN_BOOKING_API}`
          : `${API_BASE_URL}${SAVE_HGS_BOOKING_API}`;

      this.showLoading()
      axios
        .post(apiUrl, bookingData, { headers })
        .then((response) => {
          if (response.data && response.data.message) {
            const successMessage = response.data.message;
            this.showAlert(successMessage, "success");
          }

          this.$router.push({
            name: "booking-confirmation",
            query: {
              pay_reference: response.data.data.pay_reference,
            },
          });

          this.form = {
            first_name: "",
            last_name: "",
            email: "",
            address: "",
            city: "",
            country: "",
            phone: "",
            birthDate: "",
            state: "",
            zip: "",
            specialRequests: [],
          };
          this.countrySelected = null;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            const errorMessage = error.response.data.message;
            this.showAlert(errorMessage, "error");
          } else {
            this.showAlert("Error desconocido");
          }
        }).finally(() => {
          this.hideLoading()
        });
    },
  },
};
</script>
